<template>
  <div
    :ref="this.nomeRef"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    :id="this.nomeRef"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div
            class="notice d-flex w-100 bg-light-success rounded border-success border border-dashed p-6"
          >
            <span class="svg-icon svg-icon-2tx svg-icon-success me-4">
              <inline-svg src="media/icons/duotune/technology/teh003.svg" />
            </span>
            <div class="d-flex flex-stack flex-grow-1">
              <div class="fw-bold">
                <h4 class="text-gray-800 fw-bolder">Central de soluções</h4>
                <div class="fs-6 text-gray-600">
                  Verifique as soluções listadas abaixo por nossa IA.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body m-0 p-0">
          <div>
            <textarea
              class="form-control border-0"
              style="height: 400px"
              v-model="this.mensagemView"
              readonly
            />
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <div class="justify-content-end">
            <button
              class="btn btn-success svg-icon-white mb-2"
              @click="fechar()"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr016.svg"
                  class="me-2"
                />Ok
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrCreateInstanceModal, hideModalId } from "@/core/helpers/dom";
import { hideModal } from "@/core/helpers/dom";

export default {
  props: {
    nomeRef: { type: String, required: true },
    mensagem: { type: String, required: true },
  },
  emits: ["exibirHelpModal"],
  methods: {
    fechar() {
      hideModal(this.$refs.nomeRef);
      this.$emit("exibirHelpModal", false);
    },
  },
  data() {
    return {
      mensagemView: this.mensagem,
    };
  },
};
</script>

<style></style>
